import React from "react";
import './Limebar.css';

const Limebar = () => {
    return (
        <div className="limebar">
            <div className="limebar-content">
                <p>*Free Delivery Over R1500*</p>
                <p>*Free Delivery Over R1500*</p>
                <p>*Free Delivery Over R1500*</p>
            </div>
        </div>
    );
}

export default Limebar;
